import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { throwErrorMessage } from "../../../../helpers/kwikui.common.helpers";
import {
  DEFAULT_VALUES,
  VALIDATE_KEY_VALUES
} from "./progress-segmented.constants";
import { TKwikUIProgressSegmentedSize } from "./progress-segmented.definitions";
import { isValidKeyValue } from "./progress-segmented.validation";

@Component({
  selector: "kwikui-progress-segmented",
  templateUrl: "./progress-segmented.component.html",
  styleUrls: ["./progress-segmented.component.scss"]
})
export class KwikUIProgressSegmentedComponent implements OnInit, OnChanges {
  @Input() colors: string | string[] = DEFAULT_VALUES.colors;

  @Input() id: string = DEFAULT_VALUES.id;

  @Input() max: number = DEFAULT_VALUES.max;

  @Input() size: TKwikUIProgressSegmentedSize = DEFAULT_VALUES.size;

  @Input() value: number = DEFAULT_VALUES.value;

  constructor() {}

  ngOnInit(): void {
    this.colors = this.isColorsEmpty() ? "var(--tui-primary)" : this.colors;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }

    if (changes.hasOwnProperty("value") && !changes.value.firstChange) {
      this.value = changes.value.currentValue;
    }
    if (changes.hasOwnProperty("max") && !changes.max.firstChange) {
      this.max = changes.max.currentValue;
    }
    if (changes.hasOwnProperty("size") && !changes.size.firstChange) {
      this.size = changes.size.currentValue;
    }
  }

  /**
   * @description Handles setting up of error and focus on the input field is it invalid
   */
  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-progress-segmented",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  isColorsEmpty(): boolean {
    if (Array.isArray(this.colors)) {
      if (this.colors.length < 1) {
        return true;
      }
      return false;
    }
    if (this.colors === "") {
      return true;
    }
    return false;
  }
}
